/**
 * JSR
 * e_produkt_varianty_2025.js
 * JQuery funkce pro malý konfigurátor variant na detailu produktu e-shopu
 *
 * @package eshop
 *
 * @author Jiří Chalupný <jchalupny@skit.cz>
 * @copyright (c) 2007-2026 Josef Šmíd
 * @version 2.6.0
 */

$( document ).ready( function()
{
  var $konf = $( "#mini_konfigurator" );
  if ( $konf.length === 0 || $konf.find( ".maly_konf_radio" ).length === 0 ) return;

  var root = $( "input#js_root" ).val() || "";

  var posledniKodObrazku = null; // kód, pro který už proběhlo načtení obrázku
  var probihaPozadavek = false;  // ochrana proti souběžným požadavkům
  var odpovedi = {};             // krátkodobá paměť odpovědí serveru podle "typ|dekor", aby se přepínání tam a zpět nevolalo pořád dokola
  var ODPOVEDI_TTL_MS = 600000;  // 10 minut, obrázky variant se mění málo

  /**
   * Přepočítá cenu produktu podle zaškrtnutých voleb a přepíše blok #cena.
   * Formát skládání ceny odpovídá funkci v js/e_produkt.js.
   */
  function prepocitejCenu()
  {
    var cena = parseInt( $( "#z_cena" ).val(), 10 );
    if ( isNaN( cena ) ) cena = 0;

    $konf.find( ".maly_konf_radio:checked" ).each( function()
    {
      var priplatek = parseInt( $( this ).attr( "data-price" ), 10 );
      if ( !isNaN( priplatek ) ) cena += priplatek;
    } );

    var dph = parseInt( $( "#dph" ).val(), 10 );
    if ( isNaN( dph ) ) dph = 0;

    var cenaSDph, cenaBezDph;
    if ( $( "#z_cena_bez_dph" ).val() == "1" )
    {
      cenaSDph = Math.round( cena * ( 1 + dph / 100 ) );
      cenaBezDph = cena;
    }
    else
    {
      cenaSDph = cena;
      cenaBezDph = Math.round( cena / ( 1 + dph / 100 ) );
    }

    var labelSDph = $( "#cena" ).attr( "data-s" ) || "";
    var labelBezDph = $( "#cena" ).attr( "data-bezdph" ) || "";

    $( "#cena" ).html(
      "<span>" + formatujCenu( cenaSDph ) + "<i>" + labelSDph + "</i></span>" +
      "<i>" + formatujCenu( cenaBezDph ) + labelBezDph + "</i>"
    );
  }

  /**
   * Vrátí kód dekoru desky ze zaškrtnutých voleb - bere poslední volbu
   * z obrázkového výběru (data-typ="2"), ostatní výběry (rozměry apod.) ignoruje.
   */
  function vratDekor()
  {
    var dekor = null;
    $konf.find( ".maly_konf_radio:checked" ).each( function()
    {
      var $radio = $( this );
      if ( $radio.closest( ".maly_konf_vyber_hodnoty" ).attr( "data-typ" ) !== "2" ) return;
      var kod = $radio.attr( "data-dekor" );
      if ( !kod ) return;
      dekor = kod;
    } );
    return dekor;
  }

  /**
   * Načte a vymění hlavní obrázek produktu podle vybrané konfigurace.
   */
  function nactiObrazek()
  {
    var typ = $konf.attr( "data-typ-obrazku" );
    var dekor = vratDekor();
    if ( !typ || !dekor ) return;

    var kod = typ + "|" + dekor;
    if ( probihaPozadavek || kod === posledniKodObrazku ) return;

    //zpracování odpovědi, vrací true, pokud byla v pořádku (jen takovou stojí za to si zapamatovat)
    var zpracuj = function( data )
    {
      if ( typeof data === "string" )
      {
        try { data = JSON.parse( data ); }
        catch ( e ) { return false; }
      }
      if ( !data || !data.obrazky || !data.obrazky.length ) return false;

      var src = data.obrazky[0];
      $( ".slider_u_produktu:first img" ).attr( "src", src );
      $( ".fotogalerie .fotka_0 img" ).attr( "src", src );
      $( ".fotogalerie .fotka_0 a" ).attr( "href", src );
      if ( typeof refreshGalerie === "function" ) refreshGalerie( "produkt" );

      posledniKodObrazku = kod;
      return true;
    };

    //stejná konfigurace, kterou už uživatel viděl - server se nevolá, dokud platí paměť
    var zPameti = odpovedi[kod];
    if ( zPameti && ( Date.now() - zPameti.cas ) < ODPOVEDI_TTL_MS )
    {
      zpracuj( zPameti.data );
      return;
    }

    probihaPozadavek = true;

    $.get( root + "/rsadmin/_funkce/eshop_konfigurator_prisl.php", { rezim: "varianty", typ: typ, dekor: dekor } )
      .done( function( data )
      {
        if ( zpracuj( data ) ) odpovedi[kod] = { cas: Date.now(), data: data };
      } )
      .always( function()
      {
        probihaPozadavek = false;
      } );
  }

  // tooltip s popisem u obrázkových voleb (typ 2) - jako v hlavním konfigurátoru, jen na desktopu
  if ( $.fn.tooltip && window.matchMedia( "(min-width: 992px)" ).matches )
  {
    $konf.tooltip( {
      items: ".img_vyberu[title]",
      track: false,
      show: { effect: "fadeIn", duration: 200 },
      hide: { effect: "fadeOut", duration: 200 },
      position: { my: "center bottom-2", at: "center top" },
      tooltipClass: "konf-tooltip",
      content: function() { return $( this ).attr( "title" ); }
    } );
  }

  $konf.on( "change", ".maly_konf_radio", function()
  {
    prepocitejCenu();
    nactiObrazek();
  } );

  // úvodní přepočet ceny podle předvybraných voleb a načtení obrázku
  prepocitejCenu();
  nactiObrazek();
} );
